import {GOOGLE_CLIENT_ID} from '@/shared/config';

import {loadGoogleIdentity} from './loadGoogleIdentity';

type CredentialListener = (
  response: google.accounts.id.CredentialResponse
) => void;

// `initialize()` is called once per page (GSI warns on repeated calls), so the
// credential goes to whichever button is mounted at the moment.
let clientPromise: Promise<typeof google.accounts.id> | undefined;
let credentialListener: CredentialListener | undefined;

export function setCredentialListener(listener: CredentialListener) {
  credentialListener = listener;

  return () => {
    if (credentialListener === listener) {
      credentialListener = undefined;
    }
  };
}

export function getGoogleIdentityClient(
  locale: string
): Promise<typeof google.accounts.id> {
  if (!clientPromise) {
    clientPromise = loadGoogleIdentity(locale).then((accountsId) => {
      accountsId.initialize({
        client_id: GOOGLE_CLIENT_ID,
        ux_mode: 'popup',
        callback: (response) => credentialListener?.(response),
      });
      return accountsId;
    });
    clientPromise.catch(() => {
      clientPromise = undefined;
    });
  }
  return clientPromise;
}
